// File: /opt/dev_environment/assets/workspace/app-init/src/pages/auth/ForgotPasswordPage.js

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AuthService from '../../services/authService';
import './AuthPages.css';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await AuthService.requestPasswordReset(email);
      setSubmitted(true);
    } catch (err) {
      setError('Ein Fehler ist aufgetreten. Bitte versuche es erneut.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <div className="auth-status-card">
            <span className="auth-status-card__icon" role="img" aria-hidden="true">📧</span>
            <h2 className="auth-status-card__title">E-Mail gesendet</h2>
            <p className="auth-status-card__message">
              Falls ein Konto mit dieser E-Mail existiert, haben wir dir einen Link zum
              Zurücksetzen deines Passworts gesendet.
            </p>
            <Link to="/login" className="auth-action-btn">
              Zur Anmeldung
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-card__header">
          <div className="auth-card__logo">
            <span className="auth-card__logo-icon" role="img" aria-label="Karteikasten">🗃️</span>
            Vokabelkasten
          </div>
          <h2 className="auth-card__title">Passwort vergessen</h2>
          <p className="auth-card__subtitle">
            Gib deine E-Mail-Adresse ein und wir senden dir einen Link zum Zurücksetzen.
          </p>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          {error && (
            <div className="auth-error" role="alert">
              {error}
            </div>
          )}

          <div className="auth-field">
            <label className="auth-field__label" htmlFor="forgot-email">
              E-Mail
            </label>
            <input
              id="forgot-email"
              className="auth-field__input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="deine@email.de"
              autoComplete="email"
              autoFocus
            />
          </div>

          <button
            className="auth-submit-btn"
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="auth-submit-btn__spinner" />
                Wird gesendet…
              </>
            ) : (
              'Link senden'
            )}
          </button>
        </form>

        <p className="auth-footer">
          <Link to="/login">← Zurück zur Anmeldung</Link>
        </p>
      </div>
    </div>
  );
}